'use strict';

var React = require('react');

var SvgViewportShortMajor = function SvgViewportShortMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.414v4.586a1 1 0 0 1-2 0v-4.586l-1.293 1.293a1 1 0 0 1-1.414-1.414l3-3a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1-1.414 1.414l-1.293-1.293Zm2.707-8.707-3 3a1 1 0 0 1-1.414 0l-3-3a.997.997 0 0 1 .324-1.631.999.999 0 0 1 1.09.217l1.293 1.293v-4.586a1 1 0 0 1 2 0v4.586l1.293-1.293a1 1 0 1 1 1.414 1.414Zm4.293 2.293h-4l2-2h2.5a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-2.5l-2-2h4v-4Zm-14 6 2-2h-4v-4h4l-2-2h-2.5a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 1.5 1.5h2.5Z"
  }));
};

exports.SvgViewportShortMajor = SvgViewportShortMajor;
